export default {"src":"/_next/static/media/payment_success.e92613ec.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};